import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="url(#magic_pen_a)"
      d="M2.227 17.884c1.52 2.12 4.666 2.81 6.732 1.316 1.778-1.274 2.158-3.3.955-5.013-1.171-1.682-2.919-2.11-4.337-1.076-1.346.982-.863 2.444-1.583 2.977-.678.49-1.233.22-1.685.553-.33.251-.452.721-.082 1.243Zm8.14-1.88c.863-.125 1.634-.585 2.466-1.43 2.631-2.675 6.506-8.482 6.845-8.952 1.08-1.504-.78-3.374-2.271-2.308-.463.334-6.187 4.25-8.818 6.956-.802.835-1.275 1.609-1.398 2.465l1.449.418c.01-.585.329-1.15.997-1.818 2.58-2.58 8.17-6.455 8.469-6.684.185-.136.39.052.246.26-.174.262-4.008 6.007-6.567 8.607-.637.637-1.14.93-1.675 1.003l.257 1.483ZM4.148 17.79c-.061-.073-.061-.146-.01-.198.082-.084.504-.167.833-.502.791-.804.524-1.995 1.47-2.715.74-.564 1.726-.334 2.384.595.73 1.013.432 2.235-.678 3.06-1.203.899-2.888.899-3.999-.24Zm7.524-3.99 1.161-.303c-.092-1.577-1.572-3.112-3.083-3.227l-.411 1.18c.966-.062 2.364 1.348 2.333 2.35Z"
    />
    <path
      fill="url(#magic_pen_b)"
      d="M12.35 13.33c-.36-1.83-2.25-2.592-3.15-2.745l8.55-6.86 1.35.458-.45 1.372-6.3 7.774Z"
    />
    <path
      fill="url(#magic_pen_c)"
      d="M4 9a.365.365 0 0 1-.252-.095.397.397 0 0 1-.129-.245 9.866 9.866 0 0 0-.174-.92 2.29 2.29 0 0 0-.236-.612 1.075 1.075 0 0 0-.378-.38 2.05 2.05 0 0 0-.594-.222 8.174 8.174 0 0 0-.884-.14.395.395 0 0 1-.253-.128A.37.37 0 0 1 1 6c0-.097.032-.181.097-.254a.405.405 0 0 1 .252-.131c.347-.052.64-.105.877-.161.237-.056.432-.13.584-.224.153-.094.277-.219.372-.374.095-.156.176-.356.242-.6a10.3 10.3 0 0 0 .195-.916.424.424 0 0 1 .132-.245A.357.357 0 0 1 4 3c.097 0 .18.032.252.095a.397.397 0 0 1 .129.245c.054.365.112.672.174.92.062.248.14.451.236.612.095.16.221.287.378.38.157.094.355.168.594.222.238.055.533.102.884.14a.395.395 0 0 1 .253.128A.37.37 0 0 1 7 6a.368.368 0 0 1-.097.254.405.405 0 0 1-.252.131c-.35.049-.643.101-.88.159-.235.057-.429.133-.581.226a1.114 1.114 0 0 0-.372.374 2.325 2.325 0 0 0-.242.6c-.067.245-.132.55-.195.916a.418.418 0 0 1-.134.245A.36.36 0 0 1 4 9Z"
    />
    <path
      fill="url(#magic_pen_d)"
      d="M17.5 21a.304.304 0 0 1-.21-.08.33.33 0 0 1-.107-.203 8.216 8.216 0 0 0-.146-.767 1.908 1.908 0 0 0-.196-.51.896.896 0 0 0-.315-.317 1.71 1.71 0 0 0-.495-.185 6.822 6.822 0 0 0-.736-.117.33.33 0 0 1-.212-.106A.308.308 0 0 1 15 18.5c0-.08.027-.151.081-.212a.338.338 0 0 1 .21-.109 8.98 8.98 0 0 0 .73-.134 1.66 1.66 0 0 0 .488-.187.93.93 0 0 0 .31-.311c.079-.13.146-.297.201-.5a8.59 8.59 0 0 0 .163-.764.353.353 0 0 1 .11-.204A.297.297 0 0 1 17.5 16c.08 0 .15.026.21.08a.33.33 0 0 1 .107.203c.046.305.094.56.146.767.051.206.117.376.196.51.08.133.184.239.315.317.131.078.296.14.495.185.199.045.444.084.736.117a.33.33 0 0 1 .212.106c.055.06.083.132.083.215 0 .08-.027.151-.081.212a.338.338 0 0 1-.21.109c-.292.04-.536.084-.732.132-.197.048-.359.11-.486.189a.928.928 0 0 0-.31.312c-.079.13-.146.296-.201.5a8.59 8.59 0 0 0-.163.763.349.349 0 0 1-.111.204.3.3 0 0 1-.206.079Z"
    />
    <defs>
      <linearGradient
        id="magic_pen_a"
        x1={20}
        x2={20}
        y1={3}
        y2={20}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.27} stopColor="#FD0167" />
        <stop offset={0.496} stopColor="#F00188" />
        <stop offset={0.649} stopColor="#DD01A0" />
        <stop offset={0.755} stopColor="#D203B4" />
        <stop offset={1} stopColor="#C811CB" />
      </linearGradient>
      <linearGradient
        id="magic_pen_b"
        x1={20}
        x2={20}
        y1={3}
        y2={20}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.27} stopColor="#FD0167" />
        <stop offset={0.496} stopColor="#F00188" />
        <stop offset={0.649} stopColor="#DD01A0" />
        <stop offset={0.755} stopColor="#D203B4" />
        <stop offset={1} stopColor="#C811CB" />
      </linearGradient>
      <linearGradient
        id="magic_pen_c"
        x1={7}
        x2={7}
        y1={3}
        y2={9}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.27} stopColor="#FD0167" />
        <stop offset={0.496} stopColor="#F00188" />
        <stop offset={0.649} stopColor="#DD01A0" />
        <stop offset={0.755} stopColor="#D203B4" />
        <stop offset={1} stopColor="#C811CB" />
      </linearGradient>
      <linearGradient
        id="magic_pen_d"
        x1={20}
        x2={20}
        y1={16}
        y2={21}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.27} stopColor="#FD0167" />
        <stop offset={0.496} stopColor="#F00188" />
        <stop offset={0.649} stopColor="#DD01A0" />
        <stop offset={0.755} stopColor="#D203B4" />
        <stop offset={1} stopColor="#C811CB" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
